import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { InsuranceType } from '@gtpl/shared-models/common-models';
export class InsuranceDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Department id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  insuranceId: number;

  @ApiProperty()
  @MaxLength(15, { message: "Department Name allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Department name should be only alpha numeric" })
  companyName: string;


  @ApiProperty()
  emailId:string;
  @ApiProperty()
  mobileNumber:string;
  @ApiProperty()
  insuranceType:InsuranceType;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

